import { useEffect, useState } from "react";
import { MapPin, Landmark, Waves, Sun, Home, Building, Mountain, Ship } from "lucide-react";
import { clientAPI } from "@/lib/client-api";

const iconMap: Record<string, typeof MapPin> = {
  MapPin, Landmark, Waves, Sun, Home, Building, Mountain, Ship
};

const LocationSection = () => {
  const [features, setFeatures] = useState<Array<{ id: number; icon: string; title: string; description: string }>>([]);
  const [section, setSection] = useState({ title: "", description: "" });

  useEffect(() => {
    const loadData = () => {
      const featureData = clientAPI.getLocationFeatures();
      const sectionData = clientAPI.getLocationSection();
      setFeatures(featureData);
      if (sectionData) {
        setSection(sectionData);
      }
    };

    loadData();

    // Listen for updates from admin panel
    window.addEventListener('contentUpdated', loadData);
    return () => window.removeEventListener('contentUpdated', loadData);
  }, []);

  return (
    <section className="py-20 px-4 bg-muted">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            {section.title}
          </h2>
          <div className="w-20 h-1 bg-primary mx-auto mb-8"></div>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            {section.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon] || MapPin;
            return (
              <div
                key={feature.id}
                className="bg-card p-6 rounded-lg text-center hover:shadow-lg transition-shadow animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
                  <IconComponent className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
